export const environment = {
  name: 'prod',
  apiUrl: 'https://mib.motion.abb.com',
  authClientId: '4azLyJ5AZKWYaTamIWUGyG6nfsEa',
  authority: 'https://polaris.iam.motion.abb.com/oauth2/token',
  authWellknownEndpointUrl: 'https://api.accessmanagement.motion.abb.com/polaris/oidc/.well-known/openid-configuration',
  authRedirectUrl: 'https://mib.motion.abb.com/ui/callback',
  authLogoutUrl: 'https://mib.motion.abb.com/ui/logout',
  appInsightsConnString: 'fill after initial prod deploy'
};
